<template>
    <div class="host">
        <div class="dropdown show">
            <a class="btn btn-secondary dropdown-toggle" href="#" role="button"
               id="manage-users" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Manage
            </a>
            <div class="dropdown-menu" aria-labelledby="manage-users">
                <h6 class="dropdown-header">Kick user</h6>
                <a class="dropdown-item"
                   href="#"
                   v-for="member in this.members"
                   :key="member.id"
                   @click="kickUser(member)">
                    {{ member.name }}
                </a>
            </div>
        </div>
        <div>
            <button v-if="this.state" class="btn btn-danger" type="button" v-on:click="lock">End round</button>
            <button v-else class="btn btn-success" type="button" v-on:click="unlock">Start new round</button>
        </div>
    </div>
</template>

<script>
  import {mapState} from 'vuex';

  export default {
    computed: {
      ...mapState({
        code: state => state.game.code,
        state: state => state.game.state,
        members: state => state.game.members.filter(member => member.id !== state.game.host_id)
      })
    },
    methods: {
      lock() {
        this.$store.dispatch('game/activateLock');
      },
      unlock() {
        this.$store.dispatch('game/deactivateLock');
      },
      kickUser(member) {
        console.log('clicked kick', member);
        this.$store.dispatch('game/kickMember', member);
      }
    }
  }
</script>

<style lang="scss" scoped>
    .host {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
</style>
